import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from 'app/shared.module';

import { KpisCardViewComponent } from './components/kpis-card-view/kpis-card-view.component';
import { KpisTableViewComponent } from './components/kpis-table-view/kpis-table-view.component';
import { KpisZeroStateComponent } from './components/kpis-zero-state/kpis-zero-state.component';
import { KpisComponent } from './kpis.component';

@NgModule({
  declarations: [
    KpisComponent,
    KpisZeroStateComponent,
    KpisCardViewComponent,
    KpisTableViewComponent
  ],
  exports: [KpisComponent],
  imports: [BrowserModule, SharedModule, MatTableModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class KpisModule {}
